@if (isLoading()) {
  <div class="flex min-h-28 items-center justify-center" aria-live="polite">
    <korviu-loader />
  </div>
} @else if (loadError()) {
  <div class="flex flex-col items-center gap-3 rounded-lg bg-white p-4 text-center" role="alert">
    <p class="m-0 text-[0.9375rem] text-[#505760]">{{ 'promotions.missions.loadError' | translate }}</p>
    <button type="button" class="min-h-10 px-4 text-[#007dcb]" (click)="loadMissions()">
      {{ 'promotions.missions.retry' | translate }}
    </button>
  </div>
} @else {
  <div class="grid grid-cols-1 gap-6 md:grid-cols-2">
    @for (mission of missions(); track mission.id) {
      <a
        routerLink="/workspace/promotions/missions"
        class="flex min-w-0 flex-col gap-4 rounded-lg bg-white p-4 no-underline shadow-[0px_5px_15px_0px_rgba(138,142,148,0.1)]"
      >
        <div class="flex items-center gap-4">
          <img
            [src]="mission.image || 'assets/img/missions/mission-icon.svg'"
            alt=""
            class="size-10 shrink-0 rounded-lg object-cover"
          />
          <div class="min-w-0 flex-1">
            <p class="m-0 truncate text-[1rem]/[160%] font-medium text-[#2C3035]">{{ mission.name }}</p>
            <p class="m-0 line-clamp-2 text-[0.8125rem]/[160%] text-[#505760]">{{ mission.description }}</p>
          </div>
          <img
            src="assets/img/recent-activity/chevron-right.svg"
            alt=""
            class="h-[0.8125rem] w-[0.4375rem] shrink-0 scale-x-[-1]"
          />
        </div>
        @if (mission.objective_progress; as objective) {
          @if (objective.target > 0) {
            <div
              role="progressbar"
              [attr.aria-label]="mission.name"
              [attr.aria-valuenow]="mission.progress"
              aria-valuemin="0"
              aria-valuemax="100"
              [attr.aria-valuetext]="
                'promotions.missions.objectiveProgress'
                  | translate: { current: objective.current, target: objective.target }
              "
              class="h-2 overflow-hidden rounded-3xl bg-[#E6F2F1]"
            >
              <div class="h-full rounded-3xl bg-[#017F70]" [style.width.%]="mission.progress"></div>
            </div>
          }
        }
        @if (mission.reward; as reward) {
          <p class="m-0 text-center text-[0.8125rem]/[160%] text-[#737980]">
            {{ reward.value }} {{ 'promotions.campaignDetails.rewardTypes.' + reward.reward_type | translate }}
          </p>
        }
      </a>
    }
  </div>
  @if (total() > missions().length) {
    <a routerLink="/workspace/promotions/missions" class="mt-3 block text-right text-[#007dcb] no-underline">
      {{ 'promotions.viewAll' | translate }}
    </a>
  }
}
